import { useEffect, useRef } from "react";

export const useCategoryAnimation = () => {
  const refs = useRef([]);
  const observerRef = useRef(null);

  useEffect(() => {
    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Add a small delay before triggering animation for smoother effect
            setTimeout(() => {
              entry.target.classList.add("animate");
            }, 50);
            observerRef.current?.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: "80px",
      }
    );

    // Observe all current refs
    refs.current.forEach((ref) => {
      if (ref) {
        observerRef.current?.observe(ref);
      }
    });

    return () => {
      observerRef.current?.disconnect();
    };
  }, []);

  const setRef = (index) => (el) => {
    if (el && !refs.current.includes(el)) {
      refs.current[index] = el;
      // Observe immediately when ref is set
      if (observerRef.current) {
        observerRef.current.observe(el);
      }
    }
  };

  return setRef;
};
